// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DisconnectOutlinedSvg from "@fishx/icons-svg/es/asn/DisconnectOutlined";
import FishxIcon from '../components/FishxIcon';

var DisconnectOutlined = function DisconnectOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DisconnectOutlinedSvg
  }));
};

DisconnectOutlined.displayName = 'DisconnectOutlined';
export default React.forwardRef(DisconnectOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DisconnectOutlined.js
// module id = 2430
// module chunks = 0